import jwtDecode, { JwtPayload } from "jwt-decode";
export const isTokenExpired = (token: string | null): boolean => {
  if (!token) {
    return true;
  }
  let decodedToken: JwtPayload;
  try {
    decodedToken = jwtDecode<JwtPayload>(token);
  } catch (error) {
    return true;
  }
  if (!decodedToken.exp) {
    return true;
  }
  const currentTime = Math.floor(Date.now() / 1000);
  return decodedToken.exp < currentTime;
};
